import { icon } from '~commonInfra/components/Icons';
import { PageHeaderStyles } from '~src/spacesPlatform/components/layout/PageHeaderStyles';

export const Icons = {

    NotificationCenterMediumWithUnseenNotifications: icon({
      name: 'notificationCenterIcon',
      img: 'user_notifications_icon_unseen_items_medium.svg',
      hoverImg: 'user_notifications_icon_unseen_items_medium_active.svg',
      size: 'large',
      style: {
        width: PageHeaderStyles.CssVariables.cssVar(PageHeaderStyles.CssVariables.headerIconSize),
        height: PageHeaderStyles.CssVariables.cssVar(PageHeaderStyles.CssVariables.headerIconSize),
        backgroundSize: 'unset',
      }
    }),

    NotificationCenterMedium: icon({
      name: 'notificationCenterIcon',
      img: 'user_notifications_icon_medium.svg',
      hoverImg: 'user_notifications_icon_medium_active.svg',
      size: 'large',
      style: {
        width: PageHeaderStyles.CssVariables.cssVar(PageHeaderStyles.CssVariables.headerIconSize),
        height: PageHeaderStyles.CssVariables.cssVar(PageHeaderStyles.CssVariables.headerIconSize),
        backgroundSize: 'unset',
      }
    }),

    NotificationCenterWithUnseenNotifications: icon({
      name: 'notificationCenterIcon',
      img: 'user_notifications_icon_unseen_items.svg',
      hoverImg: 'user_notifications_icon_unseen_items_active.svg',
      size: 'large',
      style: {
        width: PageHeaderStyles.CssVariables.cssVar(PageHeaderStyles.CssVariables.headerIconSize),
        height: PageHeaderStyles.CssVariables.cssVar(PageHeaderStyles.CssVariables.headerIconSize),
        backgroundSize: 'unset',
      }
    }),

    NotificationCenter: icon({
      name: 'notificationCenterIcon',
      img: 'user_notifications_icon.svg',
      hoverImg: 'user_notifications_icon_active.svg',
      size: 'large',
      style: {
        width: PageHeaderStyles.CssVariables.cssVar(PageHeaderStyles.CssVariables.headerIconSize),
        height: PageHeaderStyles.CssVariables.cssVar(PageHeaderStyles.CssVariables.headerIconSize),
        backgroundSize: 'unset',
      }
    }),

    NotificationActionsMenu: icon({
      name: 'notificationActionIcon',
      img: 'actions_hover.svg',
      size: 'small',
    })
};
